import { render, staticRenderFns } from "./ReturnGoodsOrder.vue?vue&type=template&id=4e0364c3&scoped=true"
import script from "./ReturnGoodsOrder.vue?vue&type=script&lang=ts"
export * from "./ReturnGoodsOrder.vue?vue&type=script&lang=ts"
import style0 from "./ReturnGoodsOrder.vue?vue&type=style&index=0&id=4e0364c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0364c3",
  null
  
)

export default component.exports